import { useRouter } from 'next/router';

/**
 * Hook to determine if the current page is part of the widget auth flow.
 * Used to gate certain behaviors when onboarding during widget authentication.
 *
 * @returns isWidgetAuthFlow - true if on /integration/widget/auth
 */
export const useIsWidgetAuthFlow = (): { isWidgetAuthFlow: boolean } => {
  const router = useRouter();
  const isWidgetAuthFlow = router.pathname.includes('/integration/widget/auth');

  return { isWidgetAuthFlow };
};
